/* Slappy · 'Agregar outfit' agrega las prendas y te lleva directo al carrito */
(function () {
  'use strict';
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-outfit-add]');
    if (!btn) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var outfit = btn.closest('[data-outfit]');
    var idEl = document.querySelector('[data-variant-id]');
    if (!outfit || !idEl) return;
    var items = [{ id: Number(idEl.value), quantity: 1 }];
    outfit.querySelectorAll('.outfit__row:not(.outfit__row--main)').forEach(function (row) {
      var c = row.querySelector('[data-outfit-check]');
      if (!c || !c.checked) return;
      var v = row.querySelector('[data-outfit-variant]');
      if (v) items.push({ id: Number(v.value), quantity: 1 });
    });
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar.');
      window.location.href = '/cart';
    } catch (err) {
      var t = document.getElementById('Toast');
      if (t) { t.textContent = err.message; t.classList.add('is-visible'); setTimeout(function () { t.classList.remove('is-visible'); }, 2600); }
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }, true);
})();
